import { render, staticRenderFns } from "./language.vue?vue&type=template&id=b52c504e&scoped=true"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"
import style0 from "./language.vue?vue&type=style&index=0&id=b52c504e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52c504e",
  null
  
)

export default component.exports